import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntl2 } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_2: Record<PageIdIntl2, TPageConfig> = {
  [PageId.ANALYZING_INTL_2]: {
    id: PageId.ANALYZING_INTL_2,
  },
  [PageId.START_INTL_2]: {
    id: PageId.START_INTL_2,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
    legalNotice: 'fixed',
  },
  [PageId.QUESTION_1_INTL_2]: {
    id: PageId.QUESTION_1_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_2_INTL_2]: {
    id: PageId.QUESTION_2_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_3_INTL_2]: {
    id: PageId.QUESTION_3_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_4_INTL_2]: {
    id: PageId.QUESTION_4_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SPEED_FEEDBACK_INTL_2]: {
    id: PageId.SPEED_FEEDBACK_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_5_INTL_2]: {
    id: PageId.QUESTION_5_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_6_INTL_2]: {
    id: PageId.QUESTION_6_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_7_INTL_2]: {
    id: PageId.QUESTION_7_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_8_INTL_2]: {
    id: PageId.QUESTION_8_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_9_INTL_2]: {
    id: PageId.QUESTION_9_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_10_INTL_2]: {
    id: PageId.QUESTION_10_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_11_INTL_2]: {
    id: PageId.QUESTION_11_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_12_INTL_2]: {
    id: PageId.QUESTION_12_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.SMARTNESS_FEEDBACK_INTL_2]: {
    id: PageId.SMARTNESS_FEEDBACK_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_13_INTL_2]: {
    id: PageId.QUESTION_13_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_14_INTL_2]: {
    id: PageId.QUESTION_14_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_15_INTL_2]: {
    id: PageId.QUESTION_15_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_16_INTL_2]: {
    id: PageId.QUESTION_16_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_17_INTL_2]: {
    id: PageId.QUESTION_17_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_18_INTL_2]: {
    id: PageId.QUESTION_18_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_19_INTL_2]: {
    id: PageId.QUESTION_19_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_20_INTL_2]: {
    id: PageId.QUESTION_20_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.LOGICAL_SKILLS_FEEDBACK_INTL_2]: {
    id: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.QUESTION_21_INTL_2]: {
    id: PageId.QUESTION_21_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_22_INTL_2]: {
    id: PageId.QUESTION_22_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_23_INTL_2]: {
    id: PageId.QUESTION_23_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_24_INTL_2]: {
    id: PageId.QUESTION_24_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.QUESTION_25_INTL_2]: {
    id: PageId.QUESTION_25_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
    headerId: HeaderId.BACK_LOGO_MENU_TIMER,
  },
  [PageId.AGE_QUESTION_INTL_2]: {
    id: PageId.AGE_QUESTION_INTL_2,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.EDUCATION_QUESTION_INTL_2]: {
    id: PageId.EDUCATION_QUESTION_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.DISCOVER_FEEDBACKS_INTL_2]: {
    id: PageId.DISCOVER_FEEDBACKS_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.PREPARE_FLOW_INTL_2]: {
    id: PageId.PREPARE_FLOW_INTL_2,
    hasHeader: true,
    headerId: HeaderId.LOGO_ONLY,
  },
  [PageId.EMAIL_INTL_2]: {
    id: PageId.EMAIL_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.EMAIL_CONSENT_INTL_2]: {
    id: PageId.EMAIL_CONSENT_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.OFFER_INTL_2]: {
    id: PageId.OFFER_INTL_2,
  },
  [PageId.SPECIAL_DISCOUNT_INTL_2]: {
    id: PageId.SPECIAL_DISCOUNT_INTL_2,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
  [PageId.CANCEL_OFFER_INTL_2]: {
    id: PageId.CANCEL_OFFER_INTL_2,
  },
  [PageId.PAYMENT_INTL_2]: {
    id: PageId.PAYMENT_INTL_2,
  },
  [PageId.CHECKOUT_INTL_2]: {
    id: PageId.CHECKOUT_INTL_2,
  },
  [PageId.UPSELL_INTL_2]: {
    id: PageId.UPSELL_INTL_2,
  },
  [PageId.REGISTRATION_INTL_2]: {
    id: PageId.REGISTRATION_INTL_2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.NAME_ENTRY_INTL_2]: {
    id: PageId.NAME_ENTRY_INTL_2,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageId.CERTIFICATE_INTL_2]: {
    id: PageId.CERTIFICATE_INTL_2,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_LOGO_MENU,
  },
  [PageId.REPORT_INTL_2]: {
    id: PageId.REPORT_INTL_2,
    hasHeader: true,
    headerId: HeaderId.LOGO_MENU,
  },
}
